export default "/images/4437626f4f34c9b28d9439d1334bd2be.avif";